import { Field, Dropdown } from '@carboledger/ui';
import { useTranslations } from '@/hooks';
import { EMPTY_LIST } from '@/lib/utils';

/**
 * Props:
 *   options   feedstock options from buildFeedstockCategoryOptions
 *   disabled  locks the control
 */
export const FeedstockCategoryField = ({ options = EMPTY_LIST, disabled = false }) => {
  const t = useTranslations();

  return (
    <Field name="feedstockCategory">
      {({ id, name, value, onChange, onBlur, status, message }) => (
        <Dropdown
          id={id}
          name={name}
          label={t('FORM_FEEDSTOCK_CATEGORY')}
          placeholder={t('COMMON_SELECT')}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          status={status}
          message={message}
          disabled={disabled}
          options={options}
        />
      )}
    </Field>
  );
};
